import React from "react";
import { useTranslation } from "react-i18next";
import reset from "../../../assets/Frame 2996-9/resets.png";
import hideeye from "../../../assets/Frame 2996-9/statements.png";
import { useSettings } from "../../../context/SettingsContext";
import { Button } from "../../Buttons";
import { postInterfaceHideMessage } from "../../../utils/message.helper";

interface WidgetActionButtonsProps {
  handleClick: () => void;
}

const WidgetActionButtons: React.FC<WidgetActionButtonsProps> = ({
  handleClick,
}) => {
  const { t } = useTranslation();
  const { widgetDataSettings, oversizeWidget } = useSettings();

  return (
    <div className="flex space-x-2 gap-2 items-center mt-4 justify-between px-6 py-2 mb-3">
      <Button
        icon={() => (
          <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0">
            <img src={reset} alt="Icon 1" className="w-5 h-5" />
          </div>
        )}
        label={
          <p
            className={`text-xs ${
              oversizeWidget ? "font-semibold" : ""
            } text-white ml-2 pr-2 cursor-pointer break-words`}
          >
            {t("reset_settings")}
          </p>
        }
        className="flex items-center rounded-full p-2 justify-center duration-300 hover:text-blue-white hover:scale-105 hover:cursor-pointer"
        style={{
          background: widgetDataSettings?.settings?.appearance?.colors
            ?.buttonColor
            ? widgetDataSettings?.settings?.appearance?.colors
                ?.buttonGradientEnabled
              ? `linear-gradient(${widgetDataSettings?.settings?.appearance?.colors?.buttonColorGradient}, ${widgetDataSettings?.settings?.appearance?.colors?.buttonColor})`
              : widgetDataSettings?.settings?.appearance?.colors?.buttonColor
            : "#0048FF",
          borderRadius: "44px",
        }}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
          }
        }}
      />

      <Button
        icon={() => (
          <div className="w-5 h-5 rounded-full flex items-center justify-center">
            <img src={hideeye} alt="Icon 2" className="w-5 h-5 text-black" />
          </div>
        )}
        label={
          <p
            className={`text-xs ${
              oversizeWidget ? "font-semibold" : ""
            } text-white ml-2 pr-2 cursor-pointer break-word flex items-center`}
          >
            {t("hide_interface")}
          </p>
        }
        className="flex justify-center rounded-full items-center p-2 duration-300 hover:text-blue-white hover:scale-105 hover:cursor-pointer"
        style={{
          background: widgetDataSettings?.settings?.appearance?.colors
            ?.buttonColor
            ? widgetDataSettings?.settings?.appearance?.colors
                ?.buttonGradientEnabled
              ? `linear-gradient(${widgetDataSettings?.settings?.appearance?.colors?.buttonColorGradient}, ${widgetDataSettings?.settings?.appearance?.colors?.buttonColor})`
              : widgetDataSettings?.settings?.appearance?.colors?.buttonColor
            : "#0048FF",
          borderRadius: "44px",
        }}
        onClick={() => {
          postInterfaceHideMessage();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault(); // Prevent scrolling when space is pressed
            postInterfaceHideMessage();
          }
        }}
      />
    </div>
  );
};

export default WidgetActionButtons;
